import { render, staticRenderFns } from "./GradeBoxPlot.vue?vue&type=template&id=6830fe2e"
import script from "./GradeBoxPlot.vue?vue&type=script&lang=js"
export * from "./GradeBoxPlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports